var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-main-container",attrs:{"id":"app"}},[_c('router-view',{staticClass:"child-view"}),_c('input',{attrs:{"id":"activityShareData","type":"text","value":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }